module.exports = __webpack_public_path__ + "static/media/dsckiet_logo.1c308d00.jfif";